import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getDetailAmount} from './utils';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {Actions} from '../../../common/actions';

const aerialTransportation = 'A';

class LimitControl extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading) {
      const date = new Date();
      this.props.getProviderOrderLimit({'year': date.getFullYear()});
    }
  }

  render() {
    const {transport, totalLimit, totalValue, detail} = this.props;
    const remainingValue = totalLimit - totalValue;
    const orderValue = getDetailAmount(detail);

    if (!transport || transport !== aerialTransportation) {
      return null;
    }

    return (
      <React.Fragment>
        <div className={totalValue > totalLimit ? 'limit-error' : ''}>
          <strong>Pedidos Aéreos {'&'} VOR consumido / Cupo total: &nbsp;</strong>
          $ {getNumericValue(totalValue, 2)} / $ {getNumericValue(totalLimit, 2)}
        </div>
        <div className={orderValue > remainingValue ? 'limit-error' : ''}>
          <strong>Pedido actual Aéreo / Cupo disponible: &nbsp;</strong>
          $ {getNumericValue(orderValue, 2)} / $ {getNumericValue(remainingValue, 2)}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'totalLimit': state.providerOrdersControl.totalLimit,
    'totalValue': state.providerOrdersControl.totalValue,
    'detail': state.providerManualOrder.detail,
    'transport': state.providerManualOrder.transport,
    'loading': state.providerManualOrder.loading,
  };
};

const {
  getProviderOrderLimit,
} = Actions;

export default connect(mapStateToProps, {getProviderOrderLimit})(LimitControl);
